export default [
    {
        path: 'protocolSet',
        name: {list:['数字供销','设置','基本设置','协议配置']},
        component: () => import('@/views/basicConfig1/protocolSet.vue')
    },
    {
        path: 'operationsSet',
        name: {list:['数字供销','设置','基本设置','运营配置']},
        component: () => import('@/views/basicConfig1/operationsSet.vue')
    }
    ]